import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const PrevPageIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 5.33 8">
      <g id="left" transform="translate(-0.021 -0.009)">
        <path
          id="Shape"
          d="M4.874,8a.461.461,0,0,1-.286-.1L.17,4.346a.456.456,0,0,1,0-.71L4.57.1a.455.455,0,0,1,.57.71L1.182,3.99,5.16,7.19A.455.455,0,0,1,4.874,8Z"
          transform="translate(0.021 0.009)"
          fill={props.color || theme.palette.gray.main}
        />
      </g>
    </SvgIcon>
  );
};
